
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedDragNDropDirective, TooltipDirective } from '../../shared-directives/src';

@NgModule({
  declarations: [TooltipDirective, SharedDragNDropDirective],
  exports: [TooltipDirective, SharedDragNDropDirective],
  imports: [CommonModule],
})
export class DirectivesModule { }
